module.exports = "<div class=preview-details> <header class=\"top-banner item-module\"> <img class=banner :src=detailData.bannerUrl /> <div class=ct-desc> <h3 class=title>{{{ detailData.title }}}</h3> <p class=description>{{{ formatText(detailData.description) }}}</p> </div> </header> <module-view v-for=\"item in detailData.controls\" :detail-data=item></module-view> </div> <loading v-ref:loadings></loading> ";


//////////////////
// WEBPACK FOOTER
// ./src/appBackend/components/page/preview/preview/preview.tpl
// module id = 914
// module chunks = 2